export const PAGE_SIZE = 20;
export const SIDEBAR_WIDTH = 280;
